import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Link from 'next/link';
import Router from 'next/router';
import Tabs from '../tabs';
import Host from '../host';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
      alignItems: 'flex-start',
    },
  },
  headerLeft: {
    flexGrow: 1,
    paddingRight: theme.spacing(2),
  },
  title: {
    margin: 0,
  },
  titleLink: {
    color: 'rgba(0, 0, 0, 0.87)',
    textDecoration: 'none',
  },
  tabs: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  hostWrapper: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.5, 0),
    flexWrap: 'wrap',
  },
  hostBy: {
    marginRight: theme.spacing(0.5),
  },
  host: {
    '& > *': {
      marginBottom: 2,
    },
  },
}));

const EventSeriesHeader = ({ eventSeries, tab }) => {
  const classes = useStyles();

  const tabOptions = useMemo(() => {
    let tabs = [
      {
        label: 'Overview',
        value: 'overview',
        component: "a",
        href: `/event-series/${eventSeries.id}`
      }
    ];
    if (eventSeries.permissions.editable) {
      tabs.push({
        label: `Schedule (${eventSeries.upcomingEvents.length})`,
        value: 'schedule',
        component: "a",
        href: `/event-series/${eventSeries.id}/schedule`
      });
      tabs.push({
        label: 'Edit',
        value: 'edit',
        component: "a",
        href: `/event-series/${eventSeries.id}/edit`
      });
    }
    return tabs;
  }, [eventSeries]);

  const handleTabChange = useCallback((e, newTab) => {
    e.preventDefault();
    if (newTab === 'overview') {
      Router.push(
        '/event-series/[id]',
        `/event-series/${eventSeries.id}`
      );
    } else if (newTab === 'schedule') {
      Router.push(
        '/event-series/[id]/schedule',
        `/event-series/${eventSeries.id}/schedule`
      );
    } else if (newTab === 'edit') {
      Router.push(
        '/event-series/[id]/edit',
        `/event-series/${eventSeries.id}/edit`
      );
    }
  }, [eventSeries]);

  return (
    <div className={classes.header}>
      <div className={classes.headerLeft}>
        <Typography variant="h1" className={classes.title}>
          <Link
            href="/event-series/[id]"
            as={`/event-series/${eventSeries.id}`}
            className={classes.titleLink}
          >
            {eventSeries.name}
          </Link>
        </Typography>
        <div className={classes.hostWrapper}>
          <span className={classes.hostBy}>Series by</span>
          <Host
            event={eventSeries}
            className={classes.host}
          />
        </div>
      </div>

      <Tabs
        options={tabOptions}
        tab={tab}
        onTabChange={handleTabChange}
        className={classes.tabs}
      />
    </div>
  );
}

EventSeriesHeader.propTypes = {
  eventSeries: PropTypes.object.isRequired,
  tab: PropTypes.string.isRequired,
};

export default EventSeriesHeader;
